import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { CLUB, NAV } from '../data/site';
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="sticky top-0 z-50 border-b border-gold/20 bg-ink/95 backdrop-blur" data-id="element-66" data-mp="2nihavbm266tr">
      <div className="mx-auto flex max-w-shell items-center gap-4 px-5 py-3 lg:px-8" data-id="element-67" data-mp="2rlvtma1dt1aw">
        <Link to="/" className="zk-focus flex items-center gap-3" aria-label="Zanshin Karaté Club — accueil" data-id="element-68" data-mp="2wjnuhtk07xr8">
          <img src={CLUB.logo} alt="" className="h-11 w-11 rounded-full object-cover" data-id="element-69" data-mp="31cqmvyd1p15u" />
          <span className="font-display text-lg font-bold uppercase tracking-[0.14em] text-gold sm:text-xl" data-id="element-70" data-mp="36aie0q5v8j8z">
            Zanshin <span className="text-bone" data-id="element-71" data-mp="3b81wy3didk79">Karate Club</span>
          </span>
        </Link>

        <nav aria-label="Navigation principale" className="ml-auto hidden lg:block" data-id="element-72" data-mp="3fbztq7fd2ix5">
          <ul className="flex items-center gap-1" data-id="element-73" data-mp="2wmfhqlt2l657">
            {NAV.map(item => <li key={item.to} data-id="element-74" data-mp="2rkykd09so1td">
                <NavLink to={item.to} end={item.to === '/'} className={({
              isActive
            }) => `zk-focus relative block px-3 py-2 font-display text-sm uppercase tracking-[0.12em] transition-colors duration-150 ease-out ${isActive ? 'text-gold' : 'text-muted hover:text-bone'}`} data-id="element-75" data-mp="2rnuj2qtguuiv">
                  {({
                isActive
              }) => <>
                      <span className="whitespace-nowrap" data-id="element-76" data-mp="35jg3slso2s5h">{item.label}</span>
                      {isActive && <span aria-hidden className="absolute inset-x-3 -bottom-[13px] h-px bg-gold" data-id="element-77" data-mp="30klj1eb52tiq" />}
                    </>}
                </NavLink>
              </li>)}
          </ul>
        </nav>

        <a href="/informations-pratiques#inscription" className="zk-focus ml-auto hidden border border-gold px-4 py-2 font-display text-xs font-semibold uppercase tracking-[0.16em] text-gold transition-colors duration-150 ease-out hover:bg-gold hover:text-ink lg:ml-4 lg:block" data-id="element-78" data-mp="1rew6cdks2jp1">
          S’inscrire
        </a>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="menu-mobile" className="zk-focus ml-auto inline-flex h-10 w-10 items-center justify-center border border-gold/40 text-gold lg:hidden" data-id="element-79" data-mp="1mki7u2atjwg5">
          <span className="sr-only" data-id="element-80" data-mp="yr8oh6aw6763">{open ? 'Fermer le menu' : 'Ouvrir le menu'}</span>
          {open ? <XIcon size={20} aria-hidden data-id="element-81" data-mp="13q38ucoic3sb" /> : <MenuIcon size={20} aria-hidden data-id="element-82" data-mp="2t2f3a0rcbbda" />}
        </button>
      </div>

      {open && <nav id="menu-mobile" aria-label="Navigation mobile" className="border-t border-gold/20 bg-panel lg:hidden" data-id="element-83" data-mp="2y1rn0cmx02bn">
          <ul className="mx-auto max-w-shell px-5 py-2" data-id="element-84" data-mp="mdv8ww0y24h0">
            {NAV.map(item => <li key={item.to} className="border-b border-white/5 last:border-0" data-id="element-85" data-mp="hg3dhs13c082">
                <NavLink to={item.to} end={item.to === '/'} className={({
            isActive
          }) => `zk-focus block py-3 font-display text-sm uppercase tracking-[0.12em] ${isActive ? 'text-gold' : 'text-bone'}`} data-id="element-86" data-mp="w47qcfdgphix">
                  {item.label}
                </NavLink>
              </li>)}
          </ul>
        </nav>}
    </header>;
}